import React from 'react';

import {
  COMPARE_HTML_TITLE,
  COMPARE_SIDE_LABELS,
  TemplateChangeKind,
} from '../../FormChangeHistory.constants';
import HtmlTemplateFacts from '../HtmlTemplateFacts';
import PdfTemplateFacts from '../PdfTemplateFacts';
import PrismTemplateParts from '../PrismTemplateParts';

/** A compare's template differences, by kind: the changeset renderers' bodies, version → current. */
export const COMPARE_TEMPLATE_BODY = {
  [TemplateChangeKind.PRISM]: template => <PrismTemplateParts templateChanges={template} />,
  [TemplateChangeKind.PDF]: template => (
    <PdfTemplateFacts pdf={template.pdf} sideLabels={COMPARE_SIDE_LABELS} />
  ),
  [TemplateChangeKind.HTML]: template => (
    <HtmlTemplateFacts
      html={template.html}
      sideLabels={COMPARE_SIDE_LABELS}
      titles={COMPARE_HTML_TITLE}
    />
  ),
};
